import { createTheme } from '@mui/material/styles';

// Base design tokens
const tokens = {
  palette: {
    primary: { main: '#1976d2', dark: '#115293' },
    secondary: { main: '#dc004e' },
    success: { main: '#2e7d32' },
    info: { main: '#0288d1' },
    warning: { main: '#ed6c02' },
    error: { main: '#d32f2f' },
    background: { default: '#fafafa', paper: '#fff' },
    divider: 'rgba(0,0,0,0.12)'
  },
  shape: { borderRadius: 8 },
  spacing: 8, // 8px grid
  // Focus ring
  focus: {
    ring: '0 0 0 3px rgba(25, 118, 210, 0.35)'
  },
  typography: {
    fontFamily: 'Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    h1: { fontWeight: 600, fontSize: '2rem', letterSpacing: '-0.01em' },
    h2: { fontWeight: 600, fontSize: '1.6rem', letterSpacing: '-0.01em' },
    h3: { fontWeight: 600, fontSize: '1.3rem' },
    h4: { fontWeight: 600, fontSize: '1.1rem' },
    subtitle1: { fontSize: '0.95rem' },
    body1: { fontSize: '0.95rem' },
    body2: { fontSize: '0.875rem' },
    caption: { fontSize: '0.75rem' }
  }
};

const theme = createTheme({
  palette: tokens.palette,
  shape: tokens.shape,
  spacing: tokens.spacing,
  typography: tokens.typography,
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '*, *::before, *::after': { boxSizing: 'border-box' },
        /* Accessible focus styles: only show ring on interactive non-inputs */
        'a:focus-visible, button:focus-visible, [role="button"]:focus-visible, .MuiButtonBase-root:focus-visible': {
          outline: 'none',
          boxShadow: tokens.focus.ring
        },
        /* Do not draw native outline or global ring on inputs/textareas */
        'input:focus, textarea:focus, .MuiInputBase-input:focus, .MuiOutlinedInput-input:focus': {
          outline: 'none'
        },
        'input:focus-visible, textarea:focus-visible, .MuiInputBase-input:focus-visible, .MuiOutlinedInput-input:focus-visible': {
          outline: 'none',
          boxShadow: 'none'
        },
        body: {
          backgroundColor: tokens.palette.background.default
        }
      }
    },
    // Defaults/density
    MuiButton: {
      defaultProps: { size: 'small', disableElevation: true },
    },
    MuiTextField: {
      defaultProps: { size: 'small', variant: 'outlined' }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          outline: 'none'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          outline: 'none'
        },
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 2,
            borderColor: tokens.palette.primary.main
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        input: { outline: 'none' },
        root: {
          '&.Mui-focused': { boxShadow: 'none' }
        }
      }
    },
    MuiFormControl: {
      defaultProps: { size: 'small' }
    },
    MuiSelect: {
      defaultProps: { size: 'small' }
    },
    MuiTable: {
      defaultProps: { size: 'small' }
    },
    MuiPaper: {
      defaultProps: { elevation: 1 }
    },
    MuiTooltip: {
      defaultProps: { arrow: true }
    },
    // State variants
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500
        }
      }
    },
    MuiAlert: {
      defaultProps: { variant: 'standard' }
    }
  }
});

export default theme;
export { tokens };

